import React, { useEffect, useState } from "react";
import {
  CircularProgress,
  Alert, 
  AlertTitle,
} from "@mui/material";
import { Theme, useTheme } from '@mui/material/styles'
import { createStyles, makeStyles } from '@mui/styles';
import { useLocalStorage } from "../../utils/LocalStorageHook";
import { GetRoles } from "../../utils/GetSecurity";
import TableAbstraction from "../../componentUtils/TableAbstraction";
import {checkForRole} from "../../utils/GetAuth";
import LockIcon from '@mui/icons-material/Lock';
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    centerDiv: {
      textAlign: "center",
    },
    root: {},
    divWidth: {
      width: "100%",
    },
    gridSpaceable: {
      padding: theme.spacing(2),
    },
    gridMarginTop: {
      marginTop: theme.spacing(2),
    },
    primary: {
      marginTop: theme.spacing(2),
    },
  })
);
export default function SecAdminRoles() {
  const classes = useStyles();
  const [secOptions, SetSecOptions] = useState<any[]>([]);
  const [secConfig, SetSecConfig] = useState<any[]>([]);
  const [salesOrg,] = useLocalStorage("SETTINGS.salesOrg", "");
  const [doneLoading, setDoneLoading] = React.useState<boolean>();
  const [clientId,] = useLocalStorage("SETTINGS.clientId", "100");
  const enabled = checkForRole(clientId,salesOrg,'security_admin');
  const [muiTable, setMuiTable] = React.useState<any>({rpp:25});
  
  const header =  document.querySelector('ResponsiveDrawer')
  const headerAdj = header?header.clientHeight:250;
  const [TABLE_BODY_HEIGHT, setTABLE_BODY_HEIGHT] = React.useState<string>(`${window.innerHeight - headerAdj }px`);
  window.addEventListener('resize', ()=>{
    setTABLE_BODY_HEIGHT(`${window.innerHeight - headerAdj }px`);
  })
  
  useEffect(() => {
    if (doneLoading) return;
        GetRoles(salesOrg).then((v) => {
          setDoneLoading(true);
          if(v){
            SetSecOptions(v.secOptions);
            SetSecConfig(v.secConfig);
          }
        });
  }, [secOptions, secConfig, doneLoading, salesOrg]);
  return (
    <div className={classes.root}>
      {doneLoading && enabled? (
        <div>
              <TableAbstraction
                settingsKey="ADM_SAR"
                options={{
                  draggableColumns: {
                    enabled: true,
                  },
                  rowsPerPageOptions: [25, 50, 100],
                  tableBodyHeight: TABLE_BODY_HEIGHT,
                  serverSide: false,
                  selectableRows: "none",
                  rowsPerPage: muiTable.rpp,
                  onChangeRowsPerPage: (numberOfRows) => {
                    muiTable.rpp = numberOfRows;
                    setMuiTable(muiTable);
                  },
                }}
                title="Security Roles"
                columns={[
                  {
                    label: "Role ID",
                    name: "code",
                    options: {
                      searchable: true,
                      filter: false,
                    },
                  },
                  {
                    label: "Role Name",
                    name: "text",
                    options: {
                      searchable: true,
                      filter: true,
                    },
                  },
                  {
                    label: "Role Description",
                    name: "textLong",
                    options: {
                      searchable: true,
                      filter: false,
                    },
                  },
                ]}
                data={secOptions}
              />
        </div>
      ) : ( enabled ? (
        <div className={classes.centerDiv}>
          <CircularProgress color="primary" />
        </div>) : (
          <Alert severity="error">
            <AlertTitle><LockIcon/> Access Error</AlertTitle>   
            You do not currently have access to <strong>Security Admin</strong> activities for the <strong>{salesOrg}</strong> bottler. 
          </Alert>
        )
      )}
    </div>
  );
}